import config from '../config';
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../style/addMember.css";
import { CircleUserRound } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { User } from "lucide-react";
import { isUUID } from "validator";
import { useAuth } from "../context/authContext";
import axios from "axios";
import Button from "../components/Button";
import { Briefcase } from "lucide-react";
import { Trash2 } from "lucide-react";


const AddMember = () => {
  const { authData, userData } = useAuth();
  const isSuperAdmin = userData?.role === "SUPERADMIN";
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { orgName } = location.state || "";
  const { organizationId } = useParams();
  const [allCampaigns, setAllCampaigns] = useState([]);


  const isInventoryAccessEnabled = config.INVENTORY_ACCESS_ENABLED;

  const params = useParams();
  const { userId } = useParams();
  const [activeCampaigns, setActiveCampaigns] = useState([]);
  const [isActiveOnly, setIsActiveOnly] = useState(false);
  const [sortOrder, setSortOrder] = useState("A-Z"); // Default sort order is "A-Z"
  const [isCampaignsActiveOnly, setIsCampaignsActiveOnly] = useState(false);
  const [sortOrderCampaigns, setSortOrderCampaigns] = useState("A-Z"); // Default sort order is "A-Z"
  const [loading, setLoading] = useState(true);
  const [accessType, setAccessType] = useState("App Only Access"); // Single state for the slider toggle
  const [imageUrl, setImageUrl] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("success");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [initialUserData, setInitialUserData] = useState(null);
  const [initialModuleNotUsed, setInitialModuleNotUsed] = useState({});
  const [formErrors, setFormErrors] = useState([]);
  const [emailError, setEmailError] = useState("");

  const [showPasswordRules, setShowPasswordRules] = useState(false);
  const [orgVastOnly, setOrgVastOnly] = useState(false);



  // State to keep track of the active component
  const [activeComponent, setActiveComponent] = useState("security");
  const [securityPrimaryTab, setSecurityPrimaryTab] = useState("General");
  const [moduleNotUsed, setModuleNotUsed] = useState({});
  useEffect(() => {
    if (!orgVastOnly && securityPrimaryTab === "Vast") {
      setSecurityPrimaryTab("General");
    }
  }, [orgVastOnly, securityPrimaryTab]);

  const [members, setMembers] = useState([]);
  const [selectedCampaigns, setselectedCampaigns] = useState([]);
  const [memberSearch, setMemberSearch] = useState("");
  const [selectedMemberSearch, setSelectedMemberSearch] = useState("");
  const [memberSort, setMemberSort] = useState("asc");
  const [selectedMemberSort, setSelectedMemberSort] = useState("asc");
  const currentOrgId = organizationId || localStorage.getItem("currentOrgId");

  function normalizeModuleName(moduleName) {
    if (moduleName === "PreNatal Visits Module") {
      return "AnteNatal Visits Module";
    }
    return moduleName;
  }

  function transformRoleMappings(originalMappings) {
    const transformed = {};

    for (const [role, modules] of Object.entries(originalMappings)) {
      const transformedModules = {};

      for (const [moduleName, permissions] of Object.entries(modules)) {
        const normalizedName = normalizeModuleName(moduleName);
        transformedModules[normalizedName] = permissions;
      }

      transformed[role] = transformedModules;
    }

    return transformed;
  }

  const prepareDataForUpdate = (userRoles) => {
    const updateData = {};

    for (const [moduleName, permissions] of Object.entries(userRoles)) {
      const dbModuleName =
        moduleName === "AnteNatal Visits Module"
          ? "PreNatal Visits Module"
          : moduleName;
      updateData[dbModuleName] = permissions;
    }

    return updateData;
  };
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    city: "",
    state: "",
    country: "",
    organizationRole: "",
    specialty: "",
    joinedDate: "",
    notes: "",
    patientOnly: false,
    patientId: "",
    isActive: false,
    email: "",
    pin: "",
    password: "",
    hasWebAccess: false,
    backpackEMRRole: "",
    defaultSecurityRole: "NONE",
    profileFileName: "",
    securityRoles: {
      "Shared Module": {
        profile: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Profile",
        },
        canAccessInventory: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Inventory Access",
        },
        activeIssues: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Active Issues",
        },
        medications: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Medications",
        },
        summaryHistory: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Summary/History",
        },
      },
      "Primary Care Module": {
        labs: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Labs",
        },
        vitals: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Vitals",
        },
        pharmacy: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Pharmacy",
        },
        complaint: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Complaint",
        },
        examVision: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Exam/Vision",
        },
        virtualCare: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Virtual Care",
        },
        publicHealth: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Public Health",
        },
        immunizations: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Immunizations",
        },
      },
      "AnteNatal Visits Module": {
        complaint: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Complaint",
        },
        dashboard: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Dashboard",
        },
        vitals: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Vitals",
        },
        labs: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Labs",
        },
        imaging: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Imaging",
        },
        exam: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Exam",
        },
        treatment: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Treatment",
        },
        pharmacy: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Pharmacy",
        },
      },
      "Pediatric Module": {
        labs: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Labs",
        },
        vitals: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Vitals",
        },
        pharmacy: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Pharmacy",
        },
        complaint: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Complaint",
        },
        examVision: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Exam/Vision",
        },
        virtualCare: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Virtual Care",
        },
        publicHealth: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Public Health",
        },
        immunizations: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Immunizations",
        },
      },
      "Orthopedic Module": {
        exam: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Exam",
        },
        plan: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Plan",
        },
        postOp: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Post Op",
        },
        history: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "History",
        },
        surgery: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Surgery",
        },
        followUp: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Follow Up",
        },
      },
      "In Patient Module": {
        labs: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Labs",
        },
        notes: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Notes",
        },
        fluids: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Fluids",
        },
        vitals: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Vitals",
        },
        discharge: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Discharge",
        },
        treatment: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Treatment",
        },
      },
      "General Surgery Module": {
        exam: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Exam",
        },
        labs: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Labs",
        },
        plan: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Plan",
        },
        postOp: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Post Op",
        },
        vitals: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Vitals",
        },
        imaging: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Imaging",
        },
        surgery: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Surgery",
        },
        followUp: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Follow Up",
        },
        anesthesia: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Complaints",
        },
        publicHealth: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Public Health",
        },
      },

      "Cleft Lip & Palate Module": {
        exam: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Exam",
        },
        labs: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Labs",
        },
        plan: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Plan",
        },
        postOp: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Post Op",
        },
        vitals: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Vitals",
        },
        imaging: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Imaging",
        },
        surgery: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Surgery",
        },
        followUp: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Follow Up",
        },
        complaint: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Complaint",
        },
        anesthesia: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Anesthesia",
        },
      },
      "Physiotherapy Module": {
        reason: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Reason",
        },
        posture: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Posture",
        },
        motor: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Motor",
        },
        range: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Range",
        },
        gait: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Gait",
        },
        treatment: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Treatment",
        },
        plan: {
          hide: "false",
          read: "false",
          write: "false",
          readableName: "Plan",
        },
      },
    },
    selectedCampaigns,
    accessType,
    canAccessInventory: false,
  });

  const isUserRole = user.backpackEMRRole === "USER";
  const isAdminRole =
    user.backpackEMRRole === "ADMIN" || user.backpackEMRRole === "SUPERADMIN";
  const isEditingSuperAdmin =
    Boolean(userId) && user.backpackEMRRole === "SUPERADMIN";
  const isRoleSelectDisabled = !isSuperAdmin && isEditingSuperAdmin;
  const initialEmailBlank = !initialUserData?.email?.trim();
  const hasWebAppAccess =
    accessType === "Web & App Access" || user.hasWebAccess;
  const showEmailPasswordFields = isAdminRole && hasWebAppAccess;
  const canEditEmail = !userId || (initialEmailBlank && isAdminRole);

  const handleSearch = (e, isSelected = false) => {
    const value = e.target.value;
    isSelected ? setSelectedMemberSearch(value) : setMemberSearch(value);
  };
  const handleAccessToggle = () => {
    const newAccessType = accessType === "App Only Access" ? "Web & App Access" : "App Only Access";
    setAccessType(newAccessType);
    setUser((prevUser) => ({
      ...prevUser,
      accessType: newAccessType,
    }));
  };
  const passwordRules = {
    length: user.password.length >= 8,
    uppercase: /[A-Z]/.test(user.password),
    lowercase: /[a-z]/.test(user.password),
    number: /[0-9]/.test(user.password),
    specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(user.password),
  };

  const allPasswordValid = Object.values(passwordRules).every(Boolean);
  const handleClearSearch = (isSelected = false) => {
    isSelected ? setSelectedMemberSearch("") : setMemberSearch("");
  };
  const handleDeleteImage = e => {
    e.stopPropagation();

    if (!window.confirm("Do you want to delete this image?")) {
      return;
    }


    setImageUrl("");

    setUser(prev => ({ ...prev, profileFileName: "" }));

    localStorage.removeItem("profileFileName");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };



  const handleSort = (isSelected = false) => {
    if (isSelected) {
      setSelectedMemberSort((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setMemberSort((prev) => (prev === "asc" ? "desc" : "asc"));
    }
  };
  const handleBackClick = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (organizationId && isUUID(organizationId)) {
      localStorage.setItem("currentOrgId", organizationId);
    }
  }, [organizationId]);

  // Update your filterAndSortItems function to include the active status filter
  const filterAndSortItems = (
    itemList,
    search,
    sort,
    activeOnly = false,
    activeItems = []
  ) => {
    let filtered = itemList.filter(
      (item) => item.name.toLowerCase().includes(search.toLowerCase()) // Use item.name for filtering
    );

    // Filter by active status if activeOnly is true
    if (activeOnly && activeItems.length > 0) {
      filtered = filtered.filter((item) => activeItems.includes(item.name)); // Use item.name for active filtering
    }

    // Sort alphabetically by name
    return filtered.sort((a, b) => {
      if (sort === "asc") {
        return a.name.localeCompare(b.name); // Sort A-Z by name
      } else if (sort === "desc") {
        return b.name.localeCompare(a.name); // Sort Z-A by name
      }
      return 0;
    });
  };
  useEffect(() => {
    if (!userId) {
      const todayDate = new Date().toISOString().split("T")[0];
      setUser((prevUser) => ({
        ...prevUser,
        joinedDate: todayDate,
        isActive: true,
      }));
    }
  }, [userId]);

  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const response = await axios.get(
          `${config.BASE_URL}/campaigns/organization/${currentOrgId}`,

          {
            headers: {
              Authorization: `Bearer ${authData.accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        const campaignData = response.data;

        if (!Array.isArray(campaignData)) {
          console.error("Unexpected response format:", campaignData);
          return;
        }

        const campaignsWithIds = campaignData.map((campaign) => ({
          id: campaign.id,
          name: campaign.name || campaign.title,
        }));

        const activeCampaigns = campaignData
          .filter((campaign) => campaign.active)
          .map((campaign) => campaign.name || campaign.title);

        setActiveCampaigns(activeCampaigns);
        setAllCampaigns(campaignsWithIds); //  Store all, don't filter here
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      }
    };

    if (currentOrgId) {
      fetchCampaigns();
    }
  }, [currentOrgId, authData]);

  useEffect(() => {
    if (!user?.selectedCampaigns || allCampaigns.length === 0) return;

    const selectedCampaignIds = user.selectedCampaigns.map((c) =>
      typeof c === "string" ? c : c?.id || c?.CampaignId
    );

    const matched = allCampaigns.filter((campaign) =>
      selectedCampaignIds.includes(campaign.id)
    );

    const remaining = allCampaigns.filter(
      (campaign) => !selectedCampaignIds.includes(campaign.id)
    );

    setselectedCampaigns(matched);
    setMembers(remaining);
  }, [user.selectedCampaigns, allCampaigns]);

  useEffect(() => {
    if (user.profileFileName) {
      const fetchImageUrl = async () => {
        try {
          const response = await axios.get(
            `${config.BASE_URL}/get-image-url`,
            {
              params: {
                fileName: `${config.S3_BUCKET_FOLDER}/${user.profileFileName}`,
              },
              headers: {
                Authorization: `Bearer ${authData.accessToken}`,
              },
            }
          );

          setImageUrl(response.data.presignedUrl);
        } catch (error) {
          console.error("Error fetching image URL:", error);
          return null;
        }
      };

      fetchImageUrl();
    }
  }, [user.profileFileName, authData.accessToken]);

  // Fetch organization data to check vastOnly flag
  useEffect(() => {
    const fetchOrgData = async () => {
      if (!currentOrgId || !isUUID(currentOrgId)) {
        return;
      }

      try {
        const response = await fetch(
          `${config.BASE_URL}/organizations/${currentOrgId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${authData.accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const orgData = await response.json();
          setOrgVastOnly(orgData.vastOnly || false);
        }
      } catch (error) {
        console.error("Error fetching organization data:", error);
      }
    };

    fetchOrgData();
  }, [currentOrgId, authData.accessToken]);


  const handleAddItem = (campaign) => {
    if (!selectedCampaigns.some((selected) => selected.id === campaign.id)) {
      const newSelected = [...selectedCampaigns, campaign];
      setselectedCampaigns(newSelected);
      setMembers((prev) => prev.filter((item) => item.id !== campaign.id));

      //  Sync to user
      setUser((prevUser) => ({
        ...prevUser,
        selectedCampaigns: newSelected,
      }));
    }
  };

  const handleRemoveItem = (campaign) => {
    if (selectedCampaigns.some((item) => item.id === campaign.id)) {
      const updatedSelected = selectedCampaigns.filter(
        (item) => item.id !== campaign.id
      );
      setselectedCampaigns(updatedSelected);

      setMembers((prev) => {
        if (!prev.some((item) => item.id === campaign.id)) {
          return [...prev, campaign];
        }
        return prev;
      });

      //  Sync to user
      setUser((prevUser) => ({
        ...prevUser,
        selectedCampaigns: updatedSelected,
      }));
    }
  };

  const getIcon = (className = "") => {
    return <User className={className} size={10} />;
  };

  const filteredSelectedMembers = filterAndSortItems(
    selectedCampaigns,
    selectedMemberSearch,
    selectedMemberSort === "asc" ? "asc" : "desc",
    isActiveOnly,
    activeCampaigns
  );

  const filteredMembers = filterAndSortItems(
    members,
    memberSearch,
    sortOrderCampaigns === "A-Z" ? "asc" : "desc",
    isCampaignsActiveOnly,
    activeCampaigns
  );

  console.log("Filtered Members:", filteredMembers); // Debugging
  // Function to handle button click and set the active button
  const handleButtonClick = (component) => {
    setActiveComponent(component);
  };

  useEffect(() => {
    if (
      user.backpackEMRRole === "ADMIN" ||
      user.backpackEMRRole === "SUPERADMIN"
    ) {
      setAccessType("Web & App Access");
      setUser((prev) => ({
        ...prev,
        hasWebAccess: true,
        accessType: "Web & App Access",
      }));
    } else if (user.backpackEMRRole === "USER") {
      setAccessType("App Only Access");
      setShowPasswordRules(false);
      setUser((prev) => ({
        ...prev,
        hasWebAccess: false,
        accessType: "App Only Access",
        password: "",
      }));
    }
  }, [user.backpackEMRRole]);

  useEffect(() => {
    const fetchMemberData = async () => {
      console.log(`Fetching member data with ID: ${userId}`);

      if (!isUUID(userId)) {
        console.error(`Invalid UUID: ${userId}`);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${config.BASE_URL}/members/${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${authData.accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch member data");
        }

        const memberData = await response.json();

        // Convert string values to booleans in securityRoles and normalize module names
        const convertedSecurityRoles = {};
        const convertedModuleNotUsed = {};
        if (memberData.securityRoles) {
          Object.keys(memberData.securityRoles).forEach((moduleKey) => {
            // Normalize module name (convert PreNatal to AnteNatal)
            const normalizedModuleKey =
              moduleKey === "PreNatal Visits Module"
                ? "AnteNatal Visits Module"
                : moduleKey;

            convertedSecurityRoles[normalizedModuleKey] = {};

            // Persisted module-level flag (stored inside securityRoles)
            const rawNotUsed = memberData.securityRoles[moduleKey]?.__notUsed;
            if (rawNotUsed !== undefined) {
              convertedModuleNotUsed[normalizedModuleKey] =
                rawNotUsed === "true" || rawNotUsed === true;
            }

            Object.keys(memberData.securityRoles[moduleKey]).forEach(
              (subKey) => {
                if (subKey === "__notUsed") return;
                const mappedKey =
                  subKey === "publicHealth"
                    ? "screening"
                    : normalizedModuleKey === "Physiotherapy Module" &&
                        subKey === "pharmacy"
                      ? "plan"
                      : subKey;
                const subModule = memberData.securityRoles[moduleKey][subKey];
                convertedSecurityRoles[normalizedModuleKey][mappedKey] = {
                  readableName: subModule.readableName || mappedKey,
                  write: subModule.write === "true" || subModule.write === true,
                  read: subModule.read === "true" || subModule.read === true,
                  hide: subModule.hide === "true" || subModule.hide === true,
                };
              }
            );
          });
        }
        if (memberData.defaultSecurityRole === "NONE") {
          Object.keys(convertedSecurityRoles).forEach((moduleKey) => {
            Object.keys(convertedSecurityRoles[moduleKey]).forEach((subKey) => {
              convertedSecurityRoles[moduleKey][subKey] = {
                ...convertedSecurityRoles[moduleKey][subKey],
                read: false,
                write: false,
                hide: false,
              };
            });
          });
        }

        const campaigns = memberData.selectedCampaigns || [];
        const enrichedCampaigns = campaigns.map((idOrObj) => {
          const id = typeof idOrObj === "object" ? idOrObj.id : idOrObj;
          return (
            allCampaigns.find((c) => c.id === id) || { id, name: "Unnamed" }
          );
        });
        const spec = memberData.specialty ?? ""; // Ensure specialty is an empty string if null

        const loadedModuleNotUsed = convertedModuleNotUsed || {};
        const loadedSecurityRoles = convertedSecurityRoles
          ? JSON.parse(JSON.stringify(convertedSecurityRoles))
          : convertedSecurityRoles;

        const isAdminMember =
          memberData.backpackEMRRole === "ADMIN" ||
          memberData.backpackEMRRole === "SUPERADMIN";
        const resolvedAccessType =
          memberData.accessType ||
          (isAdminMember || memberData.hasWebAccess
            ? "Web & App Access"
            : "App Only Access");

        setAccessType(resolvedAccessType);
        setModuleNotUsed(loadedModuleNotUsed);
        setInitialModuleNotUsed(
          JSON.parse(JSON.stringify(loadedModuleNotUsed))
        );

        setUser((prevUser) => ({
          ...prevUser,
          ...memberData,

          accessType: resolvedAccessType,
          securityRoles: loadedSecurityRoles
            ? JSON.parse(JSON.stringify(loadedSecurityRoles))
            : loadedSecurityRoles,

          joinedDate: memberData.joinedDate
            ? memberData.joinedDate.split("T")[0]
            : "",
          specialty: spec,
          pin: "",
          selectedCampaigns: enrichedCampaigns,
          canAccessInventory: memberData.canAccessInventory ?? false,
        }));

        //updatePermissionsByRole(memberData.defaultSecurityRole);

        setselectedCampaigns(enrichedCampaigns);
        setInitialUserData({
          ...memberData,
          joinedDate: memberData.joinedDate
            ? memberData.joinedDate.split("T")[0]
            : "",
          specialty: spec,
          pin: "",
          password: "",
          selectedCampaigns: campaigns,
          securityRoles: loadedSecurityRoles
            ? JSON.parse(JSON.stringify(loadedSecurityRoles))
            : loadedSecurityRoles,
        });
      } catch (error) {
        console.error("Error fetching member data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchMemberData();
    }
  }, [userId, authData.accessToken]);
  const getCampaignIds = (campaigns) =>
    (campaigns || [])
      .map((c) =>
        typeof c === "object" ? c?.id || c?.CampaignId : c
      )
      .filter(Boolean)
      .sort();

  const isPermissionEnabled = (value) => value === true || value === "true";

  const hasCampaignSelectionChanges = (currentCampaigns, initialCampaigns) =>
    JSON.stringify(getCampaignIds(currentCampaigns)) !==
    JSON.stringify(getCampaignIds(initialCampaigns));

  const hasModuleNotUsedChanges = (current, initial) =>
    JSON.stringify(current || {}) !== JSON.stringify(initial || {});

  const hasSecurityRoleChanges = (currentRoles, initialRoles) => {
    const current = currentRoles || {};
    const initial = initialRoles || {};

    const allModules = new Set([
      ...Object.keys(current),
      ...Object.keys(initial),
    ]);

    for (const moduleKey of allModules) {
      const currPermissions = current[moduleKey] || {};
      const initPermissions = initial[moduleKey] || {};

      const allTabs = new Set([
        ...Object.keys(currPermissions),
        ...Object.keys(initPermissions),
      ]);

      for (const tabKey of allTabs) {
        if (tabKey === "__notUsed") continue;

        const curr = currPermissions[tabKey] || {};
        const init = initPermissions[tabKey] || {};

        if (
          isPermissionEnabled(curr.read) !== isPermissionEnabled(init.read) ||
          isPermissionEnabled(curr.write) !== isPermissionEnabled(init.write) ||
          isPermissionEnabled(curr.hide) !== isPermissionEnabled(init.hide)
        ) {
          return true;
        }
      }
    }

    return false;
  };

  const hasFormChanges = () => {
    if (!initialUserData || !user) return false;

    const compareKeys = [
      "firstName",
      "lastName",
      "city",
      "state",
      "country",
      "organizationRole",
      "specialty",
      "joinedDate",
      "notes",
      "patientOnly",
      "patientId",
      "isActive",
      "email",
      "hasWebAccess",
      "backpackEMRRole",
      "defaultSecurityRole",
      "accessType",
      "profileFileName",
      "canAccessInventory",
      "password",
      "pin",
    ];

    for (let key of compareKeys) {
      if (user[key] !== initialUserData[key]) return true;
    }

    if (
      hasCampaignSelectionChanges(
        selectedCampaigns,
        initialUserData.selectedCampaigns
      )
    ) {
      return true;
    }

    if (hasModuleNotUsedChanges(moduleNotUsed, initialModuleNotUsed)) {
      return true;
    }

    if (
      hasSecurityRoleChanges(
        user.securityRoles,
        initialUserData.securityRoles
      )
    ) {
      return true;
    }

    return false;
  };

  const isFormValid = () => {
    if (userId) {
      return hasFormChanges();
    }

    return (
      user.firstName.trim() !== "" &&
      user.lastName.trim() !== "" &&
      user.organizationRole.trim() !== "" &&
      user.backpackEMRRole.trim() !== "" &&
      (!userId && showEmailPasswordFields
        ? user.email.trim() !== "" && user.password.trim() !== ""
        : true)
    );
  };

  const originalRoleMappings = {
    // Surgeon Permissions
    SURGEON: {
      "Primary Care Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
        virtualCare: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Virtual Care",
        },
      },
      "AnteNatal Visits Module": {
        dashboard: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Dashboard",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        treatment: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
      },
      "Pediatric Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Virtual Care",
        },
      },
      "Orthopedic Module": {
        history: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "History",
        },
        exam: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        surgery: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "In Patient Module": {
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        notes: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Notes",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        fluids: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Fluids",
        },
        treatment: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        discharge: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Discharge",
        },
      },
      "General Surgery Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaints: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        imaging: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        anesthesia: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        exam: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        surgery: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "Cleft Lip & Palate Module": {
        anesthesia: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Shared Module": {
        profile: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Profile",
        },
        summaryHistory: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Summary/History",
        },
      },
    },
    // Nurse Permissions
    NURSE: {
      "Primary Care Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Virtual Care",
        },
        screening: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Screening",
        },
      },
      "AnteNatal Visits Module": {
        dashboard: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Dashboard",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        treatment: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
      },
      "Pediatric Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Virtual Care",
        },
        screening: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Screening",
        },
      },
      "Orthopedic Module": {
        history: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "History",
        },
        exam: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        surgery: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "In Patient Module": {
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        notes: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Notes",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        fluids: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Fluids",
        },
        treatment: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        discharge: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Discharge",
        },
      },
      "General Surgery Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaints: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        imaging: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        anesthesia: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Anesthesia",
        },
        exam: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Plan",
        },
        screening: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Screening",
        },
        surgery: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "Cleft Lip & Palate Module": {
        anesthesia: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Shared Module": {
        profile: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Profile",
        },
        summaryHistory: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Summary/History",
        },
      },
    },

    // Lab Tech Permissions
    LABTECH: {
      "Primary Care Module": {
        publicHealth: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Virtual Care",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
      },
      "AnteNatal Visits Module": {
        dashboard: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Dashboard",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        treatment: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
      },
      "Pediatric Module": {
        publicHealth: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Virtual Care",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
      },
      "Orthopedic Module": {
        history: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "History",
        },
        exam: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Plan",
        },
        surgery: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "In Patient Module": {
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
        notes: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Notes",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        fluids: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Fluids",
        },
        treatment: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Treatment",
        },
        discharge: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Discharge",
        },
      },
      "General Surgery Module": {
        publicHealth: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Public Health",
        },
        complaints: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaints",
        },
        imaging: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        anesthesia: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Anesthesia",
        },
        exam: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Plan",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
        surgery: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "Cleft Lip & Palate Module": {
        anesthesia: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Shared Module": {
        profile: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Profile",
        },
        summaryHistory: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Summary/History",
        },
      },
    },

    // Receptionist Permissions
    RECEPTIONIST: {
      "Primary Care Module": {
        publicHealth: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Public Health",
        },
        complaint: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Complaint",
        },
        immunizations: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Immunizations",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Labs",
        },
        examVision: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Virtual Care",
        },
        screening: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Screening",
        },
      },
      "AnteNatal Visits Module": {
        dashboard: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Dashboard",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        treatment: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
      },
      "Pediatric Module": {
        publicHealth: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Public Health",
        },
        complaint: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Complaint",
        },
        immunizations: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Immunizations",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Labs",
        },
        examVision: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Virtual Care",
        },
        screening: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Screening",
        },
      },
      "Orthopedic Module": {
        history: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "History",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Exam",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Plan",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Surgery",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Post Op",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Follow Up",
        },
      },
      "In Patient Module": {
        vitals: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Vitals",
        },
        notes: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Notes",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Labs",
        },
        fluids: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Fluids",
        },
        treatment: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Treatment",
        },
        discharge: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Discharge",
        },
      },
      "General Surgery Module": {
        publicHealth: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Public Health",
        },
        complaints: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Complaints",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Imaging",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Labs",
        },
        anesthesia: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Anesthesia",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Exam",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Plan",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Surgery",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Post Op",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Follow Up",
        },
        screening: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Screening",
        },
      },
      "Cleft Lip & Palate Module": {
        anesthesia: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Shared Module": {
        profile: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Profile",
        },
        summaryHistory: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Summary/History",
        },
      },
    },
    PHARMACIST: {
      "Primary Care Module": {
        publicHealth: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Virtual Care",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
      },
      "AnteNatal Visits Module": {
        dashboard: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Dashboard",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        treatment: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
      },
      "Pediatric Module": {
        publicHealth: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Virtual Care",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
      },
      "Orthopedic Module": {
        exam: {
          write: "false",
          read: "false",
          hide: "true",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Follow Up",
        },
        history: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "History",
        },
        plan: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Surgery",
        },
      },
      "In Patient Module": {
        discharge: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Discharge",
        },
        fluids: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Fluids",
        },
        labs: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Labs",
        },
        notes: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Notes",
        },
        treatment: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "General Surgery Module": {
        anesthesia: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Surgery",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Cleft Lip & Palate Module": {
        anesthesia: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Shared Module": {
        profile: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Profile",
        },
        summaryHistory: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Summary/History",
        },
      },
    },
    THERAPIST: {
      "Primary Care Module": {
        complaint: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaint",
        },
        examVision: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam/Vision",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        labs: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Labs",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
        virtualCare: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Virtual Care",
        },
      },
      "AnteNatal Visits Module": {
        dashboard: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Dashboard",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        treatment: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
      },
      "Pediatric Module": {
        complaint: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaint",
        },
        examVision: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam/Vision",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        labs: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Labs",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        screening: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Screening",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
        virtualCare: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Virtual Care",
        },
      },
      "Orthopedic Module": {
        history: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "History",
        },
        exam: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        surgery: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "In Patient Module": {
        discharge: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Discharge",
        },
        fluids: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Fluids",
        },
        labs: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Labs",
        },
        notes: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Notes",
        },
        treatment: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        vitals: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "General Surgery Module": {
        anesthesia: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Surgery",
        },
        screening: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Screening",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Cleft Lip & Palate Module": {
        anesthesia: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Shared Module": {
        profile: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Profile",
        },
        summaryHistory: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Summary/History",
        },
      },
    },

    PROVIDER: {
      "Primary Care Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Virtual Care",
        },
        screening: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Screening",
        },
      },
      "AnteNatal Visits Module": {
        dashboard: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Dashboard",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        treatment: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        pharmacy: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Pharmacy",
        },
      },
      "Pediatric Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaint: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaint",
        },
        immunizations: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Immunizations",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        examVision: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam/Vision",
        },
        pharmacy: {
          write: "false",
          read: "true",
          hide: "false",
          readableName: "Pharmacy",
        },
        virtualCare: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Virtual Care",
        },
        screening: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Screening",
        },
      },
      "Orthopedic Module": {
        history: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "History",
        },
        exam: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        surgery: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "In Patient Module": {
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        notes: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Notes",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        fluids: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Fluids",
        },
        treatment: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Treatment",
        },
        discharge: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Discharge",
        },
      },
      "General Surgery Module": {
        publicHealth: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Public Health",
        },
        complaints: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        imaging: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        vitals: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
        labs: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        anesthesia: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        exam: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        plan: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        screening: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Screening",
        },
        surgery: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        postOp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        followUp: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
      },
      "Cleft Lip & Palate Module": {
        anesthesia: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Anesthesia",
        },
        complaints: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Complaints",
        },
        exam: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Exam",
        },
        followUp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Follow Up",
        },
        imaging: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Imaging",
        },
        labs: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Labs",
        },
        plan: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Plan",
        },
        postOp: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Post Op",
        },
        surgery: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Surgery",
        },
        vitals: {
          write: "false",
          read: "false",
          hide: "false",
          readableName: "Vitals",
        },
      },
      "Shared Module": {
        profile: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Profile",
        },
        summaryHistory: {
          write: "true",
          read: "false",
          hide: "false",
          readableName: "Summary/History",
        },
      },
    },
  };

  const roleMappings = transformRoleMappings(originalRoleMappings);

  const updatePermissionsByRole = (selectedRole) => {
    if (selectedRole === "NONE") {
      setUser((prev) => ({ ...prev, securityRoles: null }));
      return;
    }

    const normalizedRole = selectedRole?.toUpperCase();
    const defaultPermissions = roleMappings[normalizedRole] || {};

    setUser((prevUser) => {
      const newSecurityRoles = {};

      //  Loop through all modules including Shared Module
      for (const [moduleKey, tabPermissions] of Object.entries(
        defaultPermissions
      )) {
        newSecurityRoles[moduleKey] = {};

        for (const [tabKey, perms] of Object.entries(tabPermissions)) {
          newSecurityRoles[moduleKey][tabKey] = {
            read: perms.read === "true",
            write: perms.write === "true",
            hide: perms.hide === "true",
            readableName: perms.readableName || tabKey,
          };
        }
      }

      return {
        ...prevUser,
        securityRoles: newSecurityRoles,
      };
    });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (
      name === "backpackEMRRole" &&
      value === "SUPERADMIN" &&
      !isSuperAdmin
    ) {
      return;
    }

    if (name === "email") {
      setEmailError("");
    }

    // If unchecking patientOnly, clear patientId
    if (name === "patientOnly" && type === "checkbox" && !checked) {
      setUser((prevUser) => ({
        ...prevUser,
        patientOnly: false,
        patientId: "",
      }));
    } else {
      setUser((prevUser) => ({
        ...prevUser,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };
  function mapScreeningToPublicHealth(securityRoles) {
    const updatedRoles = { ...securityRoles };

    Object.keys(updatedRoles).forEach((moduleKey) => {
      const module = updatedRoles[moduleKey];
      if (module.screening && !module.publicHealth) {
        module.publicHealth = { ...module.screening };
        delete module.screening;
      }
    });

    return updatedRoles;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (errors.length > 0) {
      setFormErrors(errors);
      return; // Stop form submission
    }
    setFormErrors([]);
    setEmailError("");
    const passwordValid =
      user.password.length >= 8 &&
      /[A-Z]/.test(user.password) &&
      /[a-z]/.test(user.password) &&
      /[0-9]/.test(user.password) &&
      /[!@#$%^&*(),.?":{}|<>]/.test(user.password);

    const shouldValidatePassword =
      showEmailPasswordFields &&
      (!userId || (userId && user.password && user.password.trim() !== ""));

    if (shouldValidatePassword && !passwordValid) {
      setPopupMessage("Please meet all password requirements.");
      setPopupType("error");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 4000);
      return;
    }


    if (isSubmitting) return; // prevent double submission
    setIsSubmitting(true);

    try {
      // Map selected campaign names to their UUIDs
      const selectedCampaignIds = selectedCampaigns.map(
        (campaign) => campaign.id
      );

      const processedSecurityRoles = {};
      const toDbModuleName = (moduleKey) =>
        moduleKey === "AnteNatal Visits Module"
          ? "PreNatal Visits Module"
          : moduleKey;

      if (user.securityRoles) {
        Object.entries(user.securityRoles).forEach(([moduleKey, moduleValue]) => {
          const dbModuleName = toDbModuleName(moduleKey);
          processedSecurityRoles[dbModuleName] = {};

          Object.entries(moduleValue).forEach(([subKey, subValue]) => {
            const dbSubKey = subKey === "screening" ? "publicHealth" : subKey;
            processedSecurityRoles[dbModuleName][dbSubKey] = {
              ...subValue,
              read: subValue.read ? "true" : "false",
              write: subValue.write ? "true" : "false",
              hide: subValue.hide ? "true" : "false",
            };
          });
        });
      }

      // Persist module-level "Not Used" even if securityRoles is null/empty
      Object.entries(moduleNotUsed || {}).forEach(([moduleKey, isNotUsed]) => {
        const dbModuleName = toDbModuleName(moduleKey);
        if (!processedSecurityRoles[dbModuleName]) {
          processedSecurityRoles[dbModuleName] = {};
        }
        processedSecurityRoles[dbModuleName].__notUsed = isNotUsed
          ? "true"
          : "false";
      });

      // Prepare the payload
      const payload = {
        firstName: user.firstName,
        lastName: user.lastName,
        city: user.city,
        state: user.state,
        country: user.country,
        organizationRole: user.organizationRole,
        specialty: user.specialty,
        joinedDate: user.joinedDate,
        notes: user.notes,
        patientOnly: user.patientOnly,
        patientId: user.patientId,
        isActive: user.isActive,
        email: user.email,
        hasWebAccess: user.hasWebAccess,
        backpackEMRRole: user.backpackEMRRole,
        defaultSecurityRole: user.defaultSecurityRole,
        securityRoles:
          Object.keys(processedSecurityRoles).length > 0
            ? processedSecurityRoles
            : null,
        accessType,
        selectedCampaigns: selectedCampaignIds,
        OrganizationId: currentOrgId,

        profileFileName: user.profileFileName,
        canAccessInventory: user.canAccessInventory,
      };

      if (!userId) {
        // For new users pin
        if (user.pin && user.pin.trim() !== "") {
          payload.pin = user.pin;
        }
        // New users Password
        if (user.password && user.password.trim() !== "") {
          payload.password = user.password;
        }
      } else {

        if (user.pin && user.pin.trim() !== "") {
          payload.pin = user.pin;
        }
        if (user.password && user.password.trim() !== "") {
          payload.password = user.password;
        }
      }
      const method = userId ? "PUT" : "POST";
      const url = userId
        ? `${config.BASE_URL}/members/${userId}`
        : `${config.BASE_URL}/members`;

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${authData.accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        throw new Error(
          errorDetails.message ||
            errorDetails.error ||
            "Failed to add member via API."
        );
      }

      const savedMember = await response.json();

      // Handle Cognito registration if web access is enabled
      if (savedMember.hasWebAccess) {
        if (!userId) {
          const cognitoResponse = await fetch(
            `${config.BASE_URL}/members/cognito-register`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${authData.accessToken}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                email: user.email,
                password: user.password,
              }),
            }
          );

          if (!cognitoResponse.ok) {
            const errorDetails = await cognitoResponse.json();
            throw new Error(
              errorDetails.message ||
                errorDetails.error ||
                "Failed to create user in Cognito."
            );
          }
        } else if (user.password) {
          const cognitoResponse = await fetch(
            `${config.BASE_URL}/members/cognito-update-password`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${authData.accessToken}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                email: user.email,
                password: user.password,
              }),
            }
          );

          if (!cognitoResponse.ok) {
            const errorDetails = await cognitoResponse.json();
            throw new Error(
              errorDetails.message ||
                errorDetails.error ||
                "Failed to update password in Cognito."
            );
          }
        }
      }

      const action = userId ? "updated" : "saved";
      setPopupMessage(`Member ${action} successfully!`);
      setPopupType("success");
      setShowPopup(true);

      setTimeout(() => {
        setShowPopup(false);
        navigate(`/organization/${currentOrgId}/users`, {
          state: { organizationId: currentOrgId, orgName },
        });
      }, 4000);
    } catch (error) {
      console.error("Error saving member:", error);

      const errorMessage = error.message || "";
      const isDuplicateEmail =
        /email already exists/i.test(errorMessage) ||
        /usernameexist/i.test(errorMessage) ||
        (/duplicate key/i.test(errorMessage) && /email/i.test(errorMessage));

      if (isDuplicateEmail) {
        setEmailError("This email already exists.");
      } else {
        setPopupMessage(
          errorMessage ||
            (userId ? "Error updating member!" : "Error saving member!")
        );
        setPopupType("error");
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 4000);
      }

      setIsSubmitting(false);
    }
  };

  const handlePhotoClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type and size
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      alert("Please upload a valid image file (png, jpg, jpeg).");
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      alert("File size should not exceed 2MB.");
      return;
    }

    try {
      const fileExt = file.name.includes(".")
        ? `.${file.name.split(".").pop().toLowerCase()}`
        : "";
      const uniqueFileName = `profile-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 10)}${fileExt}`;

      // Step 1: Get the presigned URL from the backend
      const response = await axios.get(
        `${config.BASE_URL}/get-presigned-url`,
        {
          params: {
            fileName: uniqueFileName,
            contentType: file.type,
          },
          headers: {
            Authorization: `Bearer ${authData.accessToken}`,
          },
        }
      );

      const { presignedUrl, fileName } = response.data;
      const uploadedFileName = (fileName || uniqueFileName).split("/").pop();

      // Step 2: Upload the file to S3 using the presigned URL
      const uploadResponse = await fetch(presignedUrl, {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      });

      if (!uploadResponse.ok) {
        const errorText = await uploadResponse.text();
        throw new Error(
          `Failed to upload the file to S3: ${uploadResponse.statusText}. Details: ${errorText}`
        );
      }

      // Step 3: Save only the file name to the state and database
      setUser((prevUser) => ({
        ...prevUser,
        profileFileName: uploadedFileName,
      }));

      // Save the file name to localStorage
      localStorage.setItem("profileFileName", uploadedFileName);
    } catch (error) {
      console.error("Logo upload error:", error);
      alert("Failed to upload the logo. Please try again.");
    }
  };
  //Changed order in alphabetical manner
  const modules = {
    "Primary Care Module": {
      complaint: { readableName: "Complaint" },
      examVision: { readableName: "Exam/Vision" },
      immunizations: { readableName: "Immunizations" },
      labs: { readableName: "Labs" },
      pharmacy: { readableName: "Pharmacy" },
      screening: { readableName: "Screening" },
      virtualCare: { readableName: "Virtual Care" },
      vitals: { readableName: "Vitals" },
    },
    "Pediatric Module": {
      complaint: { readableName: "Complaint" },
      examVision: { readableName: "Exam/Vision" },
      immunizations: { readableName: "Immunizations" },
      labs: { readableName: "Labs" },
      pharmacy: { readableName: "Pharmacy" },
      screening: { readableName: "Screening" },
      virtualCare: { readableName: "Virtual Care" },
      vitals: { readableName: "Vitals" },
    },
    "AnteNatal Visits Module": {
      complaint: { readableName: "Complaint" },
      dashboard: { readableName: "Dashboard" },
      exam: { readableName: "Exam" },
      imaging: { readableName: "Imaging" },
      labs: { readableName: "Labs" },
      treatment: { readableName: "Treatment" },
      vitals: { readableName: "Vitals" },
      pharmacy: { readableName: "Pharmacy" },
    },
    "Dental Visit Module": {
      triage: { readableName: "Triage" },
      imaging: { readableName: "Imaging" },
      vitals: { readableName: "Vitals" },
      procedures: { readableName: "Procedures" },
      planner: { readableName: "Planner" },
      pharmacy: { readableName: "Pharmacy" },
    },
    "Labor & Delivery Module": {
      dashboard: { readableName: "Dashboard" },
      labor: { readableName: "Labor" },
      newborn: { readableName: "Newborn" },
      motherPost: { readableName: "Mother Post" },
      newbornPost: { readableName: "Newborn Post" },
    },
    "Wound Care Module": {
      general: { readableName: "General" },
      vitals: { readableName: "Vitals" },
      labs: { readableName: "Labs" },
      exam: { readableName: "Exam" },
      treatment: { readableName: "Treatment" },
      compare: { readableName: "Compare" },
    },
    "Wheelchair Assessment Module": {
      general: { readableName: "General" },
      control: { readableName: "Control" },
      interface: { readableName: "Interface" },
      components: { readableName: "Components" },
      dashboard: { readableName: "Dashboard" },
    },
    "Physiotherapy Module": {
      reason: { readableName: "Reason" },
      posture: { readableName: "Posture" },
      motor: { readableName: "Motor" },
      range: { readableName: "Range" },
      gait: { readableName: "Gait" },
      treatment: { readableName: "Treatment" },
      plan: { readableName: "Plan" },
    },
    "Provider Note Module": {
      ccHpi: { readableName: "CC/HPI" },
      vitals: { readableName: "Vitals" },
      exam: { readableName: "Exam" },
      diagnostics: { readableName: "Diagnostics" },
      labs: { readableName: "Labs" },
      ap: { readableName: "A/P" },
    },
    "Side Note Module": {
      eventNote: { readableName: "Event Note" },
    },
    "Clearance Module": {
      clearance: { readableName: "Clearance" },
    },
    "Discharge Module": {
      medical: { readableName: "Medical" },
      neuroPsych: { readableName: "Neuro/Psych" },
      mobilityAdls: { readableName: "Mobility/ADLs" },
      debriefPlan: { readableName: "Debrief/Plan" },
      notes: { readableName: "Notes" },
    },
    "General Surgery Module": {
      anesthesia: { readableName: "Anesthesia" },
      complaints: { readableName: "Complaints" },
      exam: { readableName: "Exam" },
      followUp: { readableName: "Follow Up" },
      imaging: { readableName: "Imaging" },
      labs: { readableName: "Labs" },
      plan: { readableName: "Plan" },
      postOp: { readableName: "Post Op" },
      screening: { readableName: "Screening" },
      surgery: { readableName: "Surgery" },
      vitals: { readableName: "Vitals" },
    },

    "In Patient Module": {
      discharge: { readableName: "Discharge" },
      fluids: { readableName: "Fluids" },
      labs: { readableName: "Labs" },
      notes: { readableName: "Notes" },
      treatment: { readableName: "Treatment" },
      vitals: { readableName: "Vitals" },
    },
    "Orthopedic Module": {
      exam: { readableName: "Exam" },
      followUp: { readableName: "Follow Up" },
      history: { readableName: "History" },
      plan: { readableName: "Plan" },
      postOp: { readableName: "Post Op" },
      surgery: { readableName: "Surgery" },
    },
    "Cleft Lip & Palate Module": {
      anesthesia: { readableName: "Anesthesia" },
      complaints: { readableName: "Complaints" },
      exam: { readableName: "Exam" },
      followUp: { readableName: "Follow Up" },
      imaging: { readableName: "Imaging" },
      labs: { readableName: "Labs" },
      plan: { readableName: "Plan" },
      postOp: { readableName: "Post Op" },
      surgery: { readableName: "Surgery" },
      vitals: { readableName: "Vitals" },
    },
  };

  const handleDefaultRoleChange = (e) => {
    const selectedRole = e.target.value;

    setUser((prevUser) => ({
      ...prevUser,
      defaultSecurityRole: selectedRole,
    }));

    updatePermissionsByRole(selectedRole);
  };

  // const toggleRoleValue = (moduleKey, subKey, permission) => {
  //   setUser((prevUser) => ({
  //     ...prevUser,
  //     securityRoles: {
  //       ...prevUser.securityRoles,
  //       [moduleKey]: {
  //         ...prevUser.securityRoles[moduleKey],
  //         [subKey]: {
  //           ...prevUser.securityRoles[moduleKey]?.[subKey],
  //           [permission]:
  //             !prevUser.securityRoles[moduleKey]?.[subKey]?.[permission],
  //         },
  //       },
  //     },
  //   }));
  // };
  const handlePermissionChange = (moduleName, tabKey, selectedPermission) => {
    setUser((prevUser) => {
      const updatedRoles = prevUser.securityRoles ? { ...prevUser.securityRoles } : {};

      // Ensure the module and tab exist
      if (!updatedRoles[moduleName]) updatedRoles[moduleName] = {};
      if (!updatedRoles[moduleName][tabKey])
        updatedRoles[moduleName][tabKey] = {
          hide: false,
          read: false,
          write: false,
          readableName: tabKey,
        };

      // Reset all to false and set selected one to true
      updatedRoles[moduleName][tabKey] = {
        ...updatedRoles[moduleName][tabKey],
        hide: false,
        read: false,
        write: false,
        [selectedPermission]: true,
      };

      return {
        ...prevUser,
        securityRoles: updatedRoles,
      };
    });
  }; const validateEmail = (email) => {
    const errors = [];
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      errors.push("Email is required.");
    } else if (!emailRegex.test(email)) {
      errors.push("Enter a valid email address.");
    }

    return errors;
  };

  // Removed: validatePassword function

  const validateForm = () => {
    const errors = [];

    if (!user.firstName.trim()) {
      errors.push("First Name is required.");
    }
    if (!user.lastName.trim()) {
      errors.push("Last Name is required.");
    }
    if (!user.organizationRole.trim()) {
      errors.push("Organization Role is required.");
    }
    if (!user.backpackEMRRole.trim()) {
      errors.push("Backpack EMR Role is required.");
    }
    if (user.backpackEMRRole === "SUPERADMIN" && !isSuperAdmin) {
      errors.push("Only Super Admins can assign the Super Admin role.");
    }

    // Validate Patient ID if Patient Only is selected
    if (user.patientOnly && !user.patientId.trim()) {
      errors.push("Patient ID is required when Patient Only is selected.");
    }

    const needsEmailForWebAccess = showEmailPasswordFields;

    if (needsEmailForWebAccess && (!userId || initialEmailBlank)) {
      errors.push(...validateEmail(user.email));
    }

    return errors;
  };



  const toggleRoleValue = (moduleKey, subKey, selectedPermission) => {
    setUser((prevUser) => {
      const newSecurityRoles = prevUser.securityRoles ? JSON.parse(
        JSON.stringify(prevUser.securityRoles)
      ) : {};


      if (!newSecurityRoles[moduleKey]) {
        newSecurityRoles[moduleKey] = {};
      }
      if (!newSecurityRoles[moduleKey][subKey]) {
        newSecurityRoles[moduleKey][subKey] = {
          write: false,
          read: false,
          hide: false,
        };
      }

      newSecurityRoles[moduleKey][subKey].write =
        selectedPermission === "write";
      newSecurityRoles[moduleKey][subKey].read = selectedPermission === "read";
      newSecurityRoles[moduleKey][subKey].hide = selectedPermission === "hide";

      return {
        ...prevUser,
        securityRoles: newSecurityRoles, // completely new reference
      };
    });
  };

  const processUserRoles = (userRolesFromDB) => {
    const processed = {};

    for (const [moduleName, permissions] of Object.entries(userRolesFromDB)) {
      const normalizedName = normalizeModuleName(moduleName);
      processed[normalizedName] = permissions;
    }

    return processed;
  };

  const formatModuleTitle = (moduleKey) => {
    if (typeof moduleKey !== "string") return moduleKey;
    return moduleKey.replace(/\s*Module\s*$/i, "");
  };

  const renderModuleTable = (moduleKey, moduleValue) => {
    const isNotUsed = !!moduleNotUsed[moduleKey];

    return (
      <div className="module-box">
        <div className="module-header">
          <strong>{formatModuleTitle(moduleKey)}</strong>
          <label className="module-not-used">
            <input
              type="checkbox"
              checked={isNotUsed}
              onChange={(e) =>
                setModuleNotUsed((prev) => ({
                  ...prev,
                  [moduleKey]: e.target.checked,
                }))
              }
            />
            <span>Not Used</span>
          </label>
        </div>
      <table>
        <thead>
          <tr>
            <th>Tabs</th>
            <th>Write</th>
            <th>Read Only</th>
            <th>Hide</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(moduleValue).map(([subKey, subValue]) => (
            <tr key={subKey}>
              <td>{subValue.readableName}</td>
              <td>
                <input
                  type="checkbox"
                  disabled={isNotUsed}
                  checked={
                    user.securityRoles?.[moduleKey]?.[subKey]?.write === true
                  }
                  onChange={() =>
                    handlePermissionChange(moduleKey, subKey, "write")
                  }
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  disabled={isNotUsed}
                  checked={
                    user.securityRoles?.[moduleKey]?.[subKey]?.read === true
                  }
                  onChange={() =>
                    handlePermissionChange(moduleKey, subKey, "read")
                  }
                />
              </td>
              <td>
                {(moduleKey !== "Shared Module" || subKey !== "profile") && (
                  <input
                    type="checkbox"
                    disabled={isNotUsed}
                    checked={
                      user.securityRoles?.[moduleKey]?.[subKey]?.hide === true
                    }
                    onChange={() =>
                      handlePermissionChange(moduleKey, subKey, "hide")
                    }
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    );
  };

  return (
    <div className="add-member-container">
      {showPopup && <div className={`popup-${popupType}`}>{popupMessage}</div>}

      <div className="add-member-content-wrapper">
        <div className="add-member-header">
          <Button
            className="add-member-backButton"
            onClick={handleBackClick}
            text="← Back"
            color="#006d7d"
          />
        </div>
        <div className="breadcrumb-addMember">
          <span>{orgName || "ORGANIZATION"}</span> &nbsp; / &nbsp;{" "}
          <span>MEMBER</span>
        </div>

        <form onSubmit={handleSubmit} className="form-container">
          <div className="user-info-container">
            <div className="column">
              <div className="form-group">
                <label htmlFor="firstName">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  autoComplete="one-time-code"
                  value={user.firstName}
                  onChange={handleInputChange}
                  required={!userId}
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={user.lastName}
                  onChange={handleInputChange}
                  required={!userId}
                />
              </div>
              <div className="form-group">
                <label htmlFor="city">City</label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  autoComplete="one-time-code"
                  value={user.city}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="state">State/Province/Region</label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  autoComplete="one-time-code"
                  value={user.state}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="city">Country</label>
                <input
                  type="text"
                  id="country"
                  name="country"
                  autoComplete="one-time-code"
                  value={user.country}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="organizationRole">Organization Role *</label>
                <select
                  id="organizationRole"
                  name="organizationRole"
                  value={user.organizationRole}
                  onChange={handleInputChange}
                  required={!userId}
                >
                  <option value="">Select a role</option>
                  <option value="SURGEON">Surgeon</option>
                  <option value="MEDICAL_PROFESSIONAL">
                    Medical Professional
                  </option>
                  <option value="NON_MEDICAL_PROFESSIONAL">
                    Non-medical Professional
                  </option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="specialty">Medical Specialty</label>
                <input
                  type="text"
                  id="specialty"
                  name="specialty"
                  autoComplete="one-time-code"
                  value={user.specialty}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="joinedDate">Entered Date</label>
                <input
                  type="date"
                  id="joinedDate"
                  name="joinedDate"
                  value={user.joinedDate || ""}
                  onChange={handleInputChange}
                  {...(!userId && {
                    min: new Date().toISOString().split("T")[0],
                  })}
                />
              </div>
              <div className="form-group">
                <label htmlFor="notes">Notes</label>
                <textarea
                  id="notes"
                  name="notes"
                  value={user.notes}
                  onChange={handleInputChange}
                />
              </div>
              {orgVastOnly && <div style={{ display: "flex", gap: "60px", marginBottom: "15px", alignItems: "center" }}>
                <div className="form-group checkbox" style={{ marginBottom: "0 !important", minWidth: "auto", flex: "0 0 auto" }}>
                  <label htmlFor="patientOnly" style={{ marginRight: "10px" }}>Patient Only</label>
                  <input
                    type="checkbox"
                    id="patientOnly"
                    name="patientOnly"
                    checked={user.patientOnly}
                    onChange={handleInputChange}
                    style={{ width: "clamp(16px, 2vw, 20px)", height: "clamp(16px, 2vw, 20px)" }}
                  />
                </div>
                <div className="form-group" style={{ marginBottom: "0 !important", flex: "2", display: "flex", alignItems: "center" }}>
                  <label htmlFor="patientId" style={{ flex: "0 0 auto", marginRight: "10px", minWidth: "80px" }}>
                    Patient ID {user.patientOnly && <span style={{ color: "black" }}>*</span>}
                  </label>
                  <input
                    type="text"
                    id="patientId"
                    name="patientId"
                    autoComplete="one-time-code"
                    value={user.patientId}
                    onChange={handleInputChange}
                    disabled={!user.patientOnly}
                    style={{
                      backgroundColor: !user.patientOnly ? "#f5f5f5" : "white",
                      flex: "1",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "4px"
                    }}
                  />
                </div>
              </div>}
              <div className="form-group checkbox">
                <label htmlFor="isActive">Active</label>
                <input
                  type="checkbox"
                  id="isActive"
                  name="isActive"
                  checked={user.isActive}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="column">
              <div className="column">
                <div className="photo-placeholder" onClick={handlePhotoClick}>
                  {user.profileFileName ? (
                    <>
                      <img
                        src={imageUrl}
                        alt="Avatar"
                        className="avatar-preview"
                      />
                      <button
                        type="button"
                        className="delete-image-button"
                        onClick={handleDeleteImage}
                      >
                        <Trash2 size={24} />
                      </button>
                    </>
                  ) : (
                    <CircleUserRound size={200} />
                  )}
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    accept="image/*"
                  />
                </div>

              </div>
              {/* Slider for Web Only and App Only */}
              <div className="toggle-container" style={{ marginLeft: "30px" }}>
                <span className="web-app-toggle-label">
                  <b>App Only Access</b>
                </span>
                <label className="web-app-toggle-switch">
                  <input
                    type="checkbox"
                    checked={accessType === "Web & App Access"}
                    onChange={handleAccessToggle}
                    disabled={isUserRole}
                  />
                  <span className="web-app-toggle-slider"></span>
                </label>
                <span className="web-app-toggle-label">
                  <b>Web & App Access</b>
                </span>
              </div>
              {isInventoryAccessEnabled && (
                <div className="inventory-access-checkbox">
                  <input
                    type="checkbox"
                    id="canAccessInventory"
                    name="canAccessInventory"
                    checked={user.canAccessInventory}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="canAccessInventory" >
                    <b  >Inventory Access</b>
                  </label>
                </div>
              )}

              <div
                className="form-group web-access-checkbox"
                style={{ marginLeft: "30px" }}
              >
                <input
                  type="checkbox"
                  id="hasWebAccess"
                  name="hasWebAccess"
                  checked={isUserRole ? false : user.hasWebAccess}
                  onChange={handleInputChange}
                  className="web-access-input"
                  disabled={isUserRole}
                />
                <label htmlFor="hasWebAccess" className="web-access-label">
                  <b>Web Admin Access</b>
                </label>
              </div>

              <div className="form-group" style={{ marginTop: "32px" }}>
                <label htmlFor="backpackEMRRole">Admin/User Role *</label>
                <select
                  id="backpackEMRRole"
                  name="backpackEMRRole"
                  value={user.backpackEMRRole}
                  onChange={handleInputChange}
                  required={!userId}
                  disabled={isRoleSelectDisabled}
                >
                  <option value="">Select a role</option>
                  {(isSuperAdmin || isEditingSuperAdmin) && (
                    <option value="SUPERADMIN">Super Admin</option>
                  )}
                  <option value="ADMIN">Administrator</option>
                  <option value="USER">User</option>
                </select>
              </div>
              {/* Email/password only for admin roles with web access */}
              {showEmailPasswordFields && (
                <>
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <div className="form-input-wrapper">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={user.email}
                        onChange={handleInputChange}
                        required={canEditEmail}
                        disabled={!canEditEmail}
                        className={emailError ? "input-error" : ""}
                        aria-invalid={emailError ? "true" : "false"}
                        aria-describedby={emailError ? "email-error" : undefined}
                      />
                      {emailError && (
                        <div id="email-error" className="field-error">
                          {emailError}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      autoComplete="new-password"
                      value={user.password}
                      onChange={(e) => {
                        handleInputChange(e);
                        setShowPasswordRules(true);
                      }}
                      onBlur={() => {
                        if (allPasswordValid) setShowPasswordRules(false);
                      }}
                      required={!userId}
                    />

                    {showPasswordRules && (
                      <div className="password-checklist">
                        <div className={passwordRules.length ? "valid" : "invalid"}>
                          {passwordRules.length ? "✔" : "✖"} At least 8 characters
                        </div>
                        <div className={passwordRules.uppercase ? "valid" : "invalid"}>
                          {passwordRules.uppercase ? "✔" : "✖"} One uppercase letter
                        </div>
                        <div className={passwordRules.lowercase ? "valid" : "invalid"}>
                          {passwordRules.lowercase ? "✔" : "✖"} One lowercase letter
                        </div>
                        <div className={passwordRules.number ? "valid" : "invalid"}>
                          {passwordRules.number ? "✔" : "✖"} One number
                        </div>
                        <div className={passwordRules.specialChar ? "valid" : "invalid"}>
                          {passwordRules.specialChar ? "✔" : "✖"} One special character
                        </div>
                      </div>
                    )}
                  </div>

                </>
              )}
              <div className="form-group">
                <label htmlFor="pin">Pin</label>
                <input
                  type="password"
                  id="pin"
                  name="pin"
                  autoComplete="one-time-code"
                  value={user.pin}
                  onChange={handleInputChange}
                  pattern="\d{4}"
                  required={!userId} // Not required in edit mode
                />
              </div>
            </div>
          </div>
          {formErrors.length > 0 && (
            <div className="form-errors">
              {formErrors.map((error, index) => (
                <div key={index} className="error-message"> {error}</div>
              ))}
            </div>
          )}

          <div className="form-actions">
            <button
              type="submit"
              className="save-button"
              disabled={isSubmitting || !isFormValid()}
              onClick={() => {
                if (!userId) {
                  const form = document.querySelector("form");
                  if (form && !form.checkValidity()) {
                    form.reportValidity();
                    setPopupMessage("Error saving member!");
                    setPopupType("error");
                    setShowPopup(true);
                    setTimeout(() => setShowPopup(false), 4000);
                  }
                }
              }}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
          </div>
        </form>


        <div className="button-container">
          <button
            className={activeComponent === "security" ? "active" : ""}
            onClick={() => handleButtonClick("security")}
          >
            Security
          </button>
          <button
            className={activeComponent === "component2" ? "active" : ""}
            onClick={() => handleButtonClick("component2")}
          >
            Campaigns
          </button>
        </div>

        {activeComponent === "security" && (
          <div className="security-container">
            <h4>BackpackEMR Security</h4>
            <div className="security-content">
              <div className="default-role">
                <label htmlFor="defaultRole">Default Role</label>
                <select
                  id="defaultRole"
                  value={user.defaultSecurityRole}
                  onChange={(e) => {
                    const role = e.target.value;
                    setUser((prev) => ({ ...prev, defaultSecurityRole: role }));
                    updatePermissionsByRole(role);
                  }}
                >
                  <option value="NONE">None</option>
                  <option value="RECEPTIONIST">Receptionist</option>
                  <option value="LABTECH">Lab Tech</option>
                  <option value="NURSE">Nurse</option>
                  <option value="PROVIDER">Provider</option>
                  <option value="PHARMACIST">Pharmacist</option>
                  <option value="SURGEON">Surgeon</option>
                  <option value="THERAPIST">Therapist</option>
                </select>
                <button
                  className="reset-button"
                  onClick={() => {
                    setUser((prev) => ({
                      ...prev,
                      defaultSecurityRole: "NONE",
                    }));
                    updatePermissionsByRole("NONE");
                  }}
                >
                  Reset
                </button>
                <div className="shared-module">
                  <div className="shared-module-columns">
                    <div className="shared-module-column">
                      <table>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Write</th>
                            <th>Read Only</th>
                            <th>Hide</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Profile */}
                          <tr>
                            <td>Profile</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]?.profile
                                    ?.write === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "profile",
                                    "write"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]?.profile
                                    ?.read === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "profile",
                                    "read"
                                  )
                                }
                              />
                            </td>
                            <td></td>
                          </tr>

                          {/* Summary/History */}
                          <tr>
                            <td>Summary/History</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.summaryHistory?.write === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "summaryHistory",
                                    "write"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.summaryHistory?.read === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "summaryHistory",
                                    "read"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.summaryHistory?.hide === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "summaryHistory",
                                    "hide"
                                  )
                                }
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="shared-module-column">
                      <table>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Write</th>
                            <th>Read Only</th>
                            <th>Hide</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Inventory Access</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.canAccessInventory?.write === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "canAccessInventory",
                                    "write"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.canAccessInventory?.read === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "canAccessInventory",
                                    "read"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.canAccessInventory?.hide === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "canAccessInventory",
                                    "hide"
                                  )
                                }
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>Active Issues</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.activeIssues?.write === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "activeIssues",
                                    "write"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.activeIssues?.read === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "activeIssues",
                                    "read"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  user.securityRoles?.["Shared Module"]
                                    ?.activeIssues?.hide === true
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    "Shared Module",
                                    "activeIssues",
                                    "hide"
                                  )
                                }
                              />
                            </td>
                          </tr>

                          {orgVastOnly && (
                            <tr>
                              <td>Medications</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    user.securityRoles?.["Shared Module"]
                                      ?.medications?.write === true
                                  }
                                  onChange={() =>
                                    handlePermissionChange(
                                      "Shared Module",
                                      "medications",
                                      "write"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    user.securityRoles?.["Shared Module"]
                                      ?.medications?.read === true
                                  }
                                  onChange={() =>
                                    handlePermissionChange(
                                      "Shared Module",
                                      "medications",
                                      "read"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    user.securityRoles?.["Shared Module"]
                                      ?.medications?.hide === true
                                  }
                                  onChange={() =>
                                    handlePermissionChange(
                                      "Shared Module",
                                      "medications",
                                      "hide"
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="security-primary-tabs">
                <div className="button-container">
                  <button
                    type="button"
                    className={securityPrimaryTab === "General" ? "active" : ""}
                    onClick={() => setSecurityPrimaryTab("General")}
                  >
                    General
                  </button>
                  <button
                    type="button"
                    className={
                      securityPrimaryTab === "Speciality" ? "active" : ""
                    }
                    onClick={() => setSecurityPrimaryTab("Speciality")}
                  >
                    Speciality
                  </button>
                  <button
                    type="button"
                    className={securityPrimaryTab === "Surgical" ? "active" : ""}
                    onClick={() => setSecurityPrimaryTab("Surgical")}
                  >
                    Surgical
                  </button>
                  {orgVastOnly && (
                    <button
                      type="button"
                      className={securityPrimaryTab === "Vast" ? "active" : ""}
                      onClick={() => setSecurityPrimaryTab("Vast")}
                    >
                      Vast
                    </button>
                  )}
                </div>
              </div>
              <div className="modules-grid">
                {Object.entries(modules)
                  .filter(([moduleKey]) => {
                    if (securityPrimaryTab === "General") {
                      return (
                        moduleKey === "Primary Care Module" ||
                        moduleKey === "Pediatric Module" ||
                        moduleKey === "In Patient Module"
                      );
                    }

                    if (securityPrimaryTab === "Speciality") {
                      return (
                        moduleKey === "AnteNatal Visits Module" ||
                        moduleKey === "Labor & Delivery Module" ||
                        moduleKey === "Dental Visit Module" ||
                        moduleKey === "Wound Care Module" ||
                        moduleKey === "Wheelchair Assessment Module" ||
                        moduleKey === "Physiotherapy Module"
                      );
                    }

                    if (securityPrimaryTab === "Surgical") {
                      return (
                        moduleKey === "General Surgery Module" ||
                        moduleKey === "Orthopedic Module" ||
                        moduleKey === "Cleft Lip & Palate Module"
                      );
                    }

                    if (securityPrimaryTab === "Vast") {
                      return (
                        moduleKey === "Side Note Module" ||
                        moduleKey === "Clearance Module" ||
                        moduleKey === "Provider Note Module" ||
                        moduleKey === "Discharge Module"
                      );
                    }

                    return true;
                  })
                  .map(([moduleKey, moduleValue]) =>
                    renderModuleTable(moduleKey, moduleValue)
                  )}
              </div>
            </div>
          </div>
        )}
        {activeComponent === "component2" && (
          <div className="security-container">
            <div className="devices-section">
              <div className="devices-column">
                <h3>Campaigns</h3>
                <div className="search-bar">
                  <input
                    type="text"
                    placeholder="Search for..."
                    value={selectedMemberSearch}
                    onChange={(e) => handleSearch(e, true)}
                  />
                  <button
                    className="add-member-clear-button"
                    onClick={() => handleClearSearch(true)}
                    style={{
                      backgroundColor: selectedMemberSearch
                        ? "#006d7d"
                        : "grey",
                    }}
                    disabled={!selectedMemberSearch}
                  >
                    Clear
                  </button>
                </div>
                <div className="sort-filter-container">
                  <div className="inline-container">
                    <div className="organization-sort">
                      <span className="sort-label">Sort By:</span>
                      <select
                        className="organization-sort-select"
                        value={selectedMemberSort === "asc" ? "A-Z" : "Z-A"}
                        onChange={() => handleSort(true)}
                      >
                        <option value="A-Z">A → Z</option>
                        <option value="Z-A">Z → A</option>
                      </select>
                    </div>
                    <div className="toggle-container">
                      <span>
                        <strong>Show All</strong>
                      </span>
                      <label className="toggle-switch">
                        <input
                          type="checkbox"
                          checked={isActiveOnly}
                          onChange={() => setIsActiveOnly((prev) => !prev)}
                        />
                        <span className="toggle-slider"></span>
                      </label>
                      <span>
                        <strong>Active Only</strong>
                      </span>
                    </div>
                  </div>
                </div>

                <ul className="device-list">
                  {filteredSelectedMembers.map((campaign) => (
                    <li
                      key={campaign.id}
                      onClick={() => handleRemoveItem(campaign)}
                      className="member-campaign-wrapper"
                    >
                      <Briefcase size={40} className="member-campaign-icon" />
                      <div className="member-campaign-text">
                        <div className="member-campaign-name">
                          {campaign.name}
                        </div>
                        <span className="member-campaign-colon">:</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="devices-column">
                <h3>
                  {orgName
                    ? `"${orgName}" Campaigns`
                    : `"Organization" Campaigns`}
                </h3>
                <div className="search-bar">
                  <input
                    type="text"
                    placeholder="Search for..."
                    value={memberSearch}
                    onChange={(e) => handleSearch(e)}
                  />
                  <button
                    className="add-member-clear-button"
                    onClick={() => handleClearSearch()}
                    style={{
                      backgroundColor: memberSearch ? "#006d7d" : "grey",
                    }}
                    disabled={!memberSearch}
                  >
                    Clear
                  </button>
                </div>
                <div className="sort-filter-container">
                  <div className="inline-container">
                    <div className="organization-sort">
                      <span className="sort-label">Sort By:</span>
                      <select
                        className="organization-sort-select"
                        value={sortOrderCampaigns}
                        onChange={(e) => setSortOrderCampaigns(e.target.value)}
                      >
                        <option value="A-Z">A → Z</option>
                        <option value="Z-A">Z → A</option>
                      </select>
                    </div>
                    <div className="toggle-container">
                      <span>
                        <strong>Show All</strong>
                      </span>
                      <label className="toggle-switch">
                        <input
                          type="checkbox"
                          checked={isCampaignsActiveOnly}
                          onChange={() =>
                            setIsCampaignsActiveOnly((prev) => !prev)
                          }
                        />
                        <span className="toggle-slider"></span>
                      </label>
                      <span>
                        <strong>Active Only</strong>
                      </span>
                    </div>
                  </div>
                </div>

                <ul className="device-list">
                  {filteredMembers.map((campaign) => (
                    <li
                      key={campaign.id}
                      onClick={() => handleAddItem(campaign)}
                      className="member-campaign-wrapper"
                    >
                      <Briefcase size={40} className="member-campaign-icon" />
                      <div className="member-campaign-text">
                        <div className="member-campaign-name">
                          {campaign.name}
                        </div>
                        <span className="member-campaign-colon">:</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddMember;
